/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Presets_None_TitleInputs */



/**
* | output |
* | --- |
* | "No Presets Found" |
*
* @param {Subtitle_Export_Presets_None_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_presets_none_title = /** @type {((inputs?: Subtitle_Export_Presets_None_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Presets_None_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun préréglage trouvé")
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine Voreinstellungen gefunden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun preset trovato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Предустановки не найдены")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se encontraron ajustes preestablecidos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("未找到预设")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プリセットが見つかりません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोई प्रीसेट नहीं मिला")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhuma predefinição encontrada")
	return /** @type {LocalizedString} */ ("No Presets Found")
});